module.exports = "/packs/012-08c4efaf2eb0ce2272a9e30e2d60506f.jpg";